import React from "react";
import RoundButton from "./RoundButton";

interface BackButtonProps {
  onClick: () => void;
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick, className = "" }) => {
  return (
    <RoundButton
      onClick={onClick}
      buttonClassName={className}
      icon={"d-arrow-left"}
    />
  );
};

export default BackButton;
